import { useContext } from 'react';
import { ArrayFieldItemApiContext } from '../Context.js';

function useArrayFieldItemApi() {
  return useContext(ArrayFieldItemApiContext);
}

export { useArrayFieldItemApi };
